import { render, staticRenderFns } from "./ResouresPage.vue?vue&type=template&id=0acc3dd3&"
import script from "./ResouresPage.vue?vue&type=script&lang=js&"
export * from "./ResouresPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports